import React, { FC, MutableRefObject, useCallback, useRef } from 'react';
import classNames from 'classnames';

import { ColumnHeaders } from '../../../../ui/data-grid/components/column-headers';
import { useDataGridViewportRef } from '../../../../ui/data-grid/components/data-grid-layout-context';
import { usePredictionsInfoContext } from '../../context/predictions-info-context';

import grid from '../../../../ui/data-grid/components/grid.scss';

interface Props {
  columns: string[];
  headerRef: React.MutableRefObject<HTMLDivElement | null>;
}

export const StickyHeaders: FC<Props> = ({ columns, headerRef }) => {
  const { periodType, rowHeaderWidth } = usePredictionsInfoContext();
  const dataGridViewportRef = useDataGridViewportRef();
  const setHeaderRef = useCallback(
    (element: HTMLDivElement | null) => {
      headerRef.current = element;
      dataGridViewportRef?.(element);
    },
    [dataGridViewportRef, headerRef]
  );

  const wrapperClasses = classNames({
    [grid.wrapper]: true
  });

  if (!periodType) {
    return null;
  }

  const tableInnerClasses = classNames({
    [grid.tableInner]: true
  });

  return (
    <div className={grid.isSticky} style={{ height: 30 }}>
      <div className={wrapperClasses}>
        <div className={grid.table} style={{ marginLeft: rowHeaderWidth }}>
          <div className={tableInnerClasses} ref={setHeaderRef} tabIndex={0}>
            <ColumnHeaders headerKeys={columns} periodType={periodType} />
          </div>
        </div>
      </div>
    </div>
  );
};

export function useStickyHeader(): [MutableRefObject<HTMLDivElement | null>, (scrollLeft: number) => void] {
  const ref = useRef<HTMLDivElement | null>(null);
  const setScrollLeft = useCallback((scrollLeft: number) => {
    if (ref.current) {
      const sl = ref!.current!.scrollLeft;
      if (scrollLeft !== sl) {
        ref!.current!.scrollLeft = scrollLeft;
      }
    }
  }, []);

  return [ref, setScrollLeft];
}
